import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import Services from "../components/Services";
import ForWho from "../components/ForWho";
import Benefits from "../components/Benefits";

export default function ServicesPage() {
  return (
    <div data-testid="page-oferta">
      <PageHeader
        eyebrow="Oferta"
        title={
          <>
            Kompleksowe wsparcie dla firm{" "}
            <span className="gold-gradient-text italic">transportowych</span> i{" "}
            <span className="gold-gradient-text italic">spedycyjnych</span>
          </>
        }
        subtitle="Od budowy firmy od zera, przez restrukturyzację, aż po optymalizację i weryfikację klientów. Poniżej pięć obszarów, w których pomagam najczęściej."
      />
      <Services />
      <ForWho />
      <Benefits />
      <PageCTA
        title="Który z obszarów dotyczy Twojej firmy?"
        text="Napisz mi kilka zdań — odezwę się i wspólnie zobaczymy od czego zacząć."
        buttonLabel="Napisz do mnie"
        to="/kontakt"
        secondary={{ to: "/kalkulator", label: "Sprawdź rentowność" }}
      />
    </div>
  );
}
